import { Component, Inject, SecurityContext, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { ToastService } from 'src/app/services/toast.service';

export interface ConfirmDialogData {
    title: string;
    message: string;
    primaryButtonText: string;
    primaryCallback?: (val?: any) => Observable<any>;
    successMessage?: string;
    secondaryButtonText: string;
    errorMessage?: string;
}

@Component({
  standalone: false,
    selector: "app-confirm-dialog",
    templateUrl: "./confirmDialog.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./confirmDialog.component.scss"],
})
export class ConfirmDialogComponent {
    isLoading = false;
    sanitizedMessage: string;

    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
        private toastService: ToastService,
        private sanitizer: DomSanitizer) {
        this.sanitizedMessage = this.sanitizer.sanitize(SecurityContext.HTML, this.data.message) || '';
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }

    primaryClick() {
        if (this.data.primaryCallback) {
            this.isLoading = true;
            this.data.primaryCallback().subscribe(
                (result) => {
                    this.toastService.showSuccess(
                        this.data.successMessage,
                        true,
                    );
                    this.isLoading = false;
                    this.dialogRef.close(result);
                },
                (error) => {
                    const message =
                        this.data.errorMessage || "An error has occurred";
                    this.toastService.displayErrorMessage(message, true);
                    this.isLoading = false;
                },
            );
        } else {
            this.dialogRef.close(true);
        }
    }
}
